export function jsonToMap<Key, Value>(json: string | null): Map<Key, Value> {
    if (!json) {
        return new Map<Key, Value>();
    }

    return new Map<Key, Value>(JSON.parse(json));
}
